import {ChangeDetectionStrategy, Component, forwardRef} from '@angular/core';
import {ScrollingAxis} from '../custom-scrollbar/scrollbar';
import {SCROLLING_BAR, ScrollingBarComponent} from './scrolling-bar.component';

@Component({
    selector: 'scrollingBar[vertical]',
    templateUrl: './scrolling-bar.component.html',
    styleUrls: ['./scrolling-bar.component.scss'],
    providers: [
        {
            provide: SCROLLING_BAR,
            useExisting: forwardRef(() => ScrollingBarVerticalComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScrollingBarVerticalComponent extends ScrollingBarComponent {

    public override readonly axis: ScrollingAxis = ScrollingAxis.Y;

}
